export default Object.freeze({
    
	"1030": {
		"S": "Sí",
		"N": "No"
	},
	"1090": {
		"1": "Enfermedad",
		"2": "Accidente no laboral",
		"3": "Accidente de trabajo",
		"4": "Enfermedad profesional",
		"5": "Periodo de observación"
	},
	"1100": {
		"S": "Se acredita carencia",
		"N": "No se acredita carencia",
		"P": "Consulta la Dirección Provincial del INSS."
	},
	"1110": {
		"1": "Muy corto",
		"2": "Corto",
		"3": "Medio",
		"4": "Largo"
	},
	"1172": {
		"1": "Pago directo",
		"2": "Pago delegado"
	},
	"1173": {
		"1": "El subsidio se abonará a cargo de la entidad gestora o colaboradora que cubra la IT por contingencias comunes desde el mismo día de la baja. No existe posibilidad de recaída.",
		"2": "El subsidio se abonará a cargo de la entidad gestora o colaboradora que cubra la IT por contingencias comunes desde el día siguiente al de la baja en el trabajo, estando a cargo del empresario el salario íntegro correspondiente al día de la baja. Existe posibilidad de recaída.",
		"4": "Proceso de IT derivado de enfermedad común asimilado a AT para los efectos económicos. Existe posibilidad de recaída. No se exige carencia.",
		"6": "El subsidio se abonará a cargo de la entidad gestora o colaboradora que cubra la IT por contingencias comunes desde el mismo día de la baja. Existe posibilidad de recaída. La prestación consistirá en un subsidio equivalente al 100% de la base reguladora establecida para la prestación de IT CC."
	},
	"1174": {
		"0": "Cuando no se trate de una IT internacional.",
		"1": "IT internacional UE/EEE/Suiza/Reino Unido",
		"2": "IT internacional convenio bilateral",
		"3": "IT internacional sin convenio"
	},
	"1190": {
		"1": "Leve",
		"2": "Grave",
		"3": "Muy grave"
	},
	"1191": {
		"H": "Hospitalaria",
		"A": "Ambulatoria"
	},
	"1650": {
		"A": "Aprobada",
		"D": "Denegada",
		"M": "Demora de Calificación"
	},
	"1670": {
		"1": "A instancia de parte (trabajador)",
		"2": "A propuesta del Servicio Público de Salud",
		"3": "A propuesta del INSS",
		"4": "Inspección de Trabajo",
		"5": "A propuesta de la Mutua",
		"6": "Empresa colaboradora",
		"7": "Resolución judicial"
	},
	"1700": {
		"1": "Incapacidad Permanente Parcial",
		"2": "Incapacidad Permanente Total",
		"3": "Incapacidad Permanente Absoluta",
		"4": "Incapacidad Permanente Gran Invalidez",
		"5": "Lesión permanente no incapacitante."
	},
	"1805": {
		"A": "Aprobada",
		"D": "Denegada"
	},
	"1810": {
		"O": "Ordinaria",
		"D": "Demorada",
		"P": "Parcial",
		"A": "Activa",
		"C": "Artistas"
	},
	"1910": {
		"NC": "Nacimiento",
		"RE": "Riesgo",
		"RL": "Riesgo",
		"CM": "Cuidado del menor",
		"CL": "Corresponsabilidad del Cuidado del Lactante"
	},
	"T-2": {
		"0111": "Régimen General",
		"0112": "Régimen General. Artistas",
		"0114": "Régimen General. Profesionales taurinos. Futuro uso",
		"0131": "Régimen General. Sistema especial Resina. Futuro uso",
		"0132": "Régimen General. Sistema especial de Frutas, Hortalizas y conservas Vegetales",
		"0134": "Régimen General. Sistema especial manipulado y empaquetado tomate fresco",
		"0135": "Régimen General. Sistema especial Industria Hostelera",
		"0136": "Régimen General. Sistema especial trabajadores fijos discontinuos en empresas de exhibición de cine y salas de bailes, discotecas y salas fiesta",
		"0137": "Régimen General. Sistema especial de trabajadores discontinuos en empresas de estudios de mercado y opinión pública",
		"0138": "Régimen General. Sistema Especial para Empleados de Hogar",
		"0163": "Régimen General. Sistema Especial Agrario. Actividad en CCC",
		"0521": "Régimen Especial Trabajadores Autónomos",
		"0613": "Régimen Especial Agrario (Jornadas Reales) Integrado en Régimen General desde 1/1/2012",
		"0811": "Régimen Especial de los trabajadores del Mar, Trabajadores por cuenta ajena grupo 1",
		"0812": "Régimen Especial de los trabajadores del Mar. Trabajadores por cuenta ajena grupo 2A",
		"0813": "Régimen Especial de los trabajadores del Mar. Trabajadores por cuenta ajena grupo 2B",
		"0814": "Régimen Especial de los trabajadores del Mar. Trabajadores por cuenta ajena grupo 3",
		"0821": "Régimen Especial de los trabajadores del Mar. Armadores y asimilados por cuenta ajena Grupo 1. Baja desde 1/1/2016",
		"0822": "Régimen Especial Trabajadores del Mar. Armadores y asimilados por cuenta ajena Grupo 2A. Baja desde 1/1/2016",
		"0823": "Régimen Especial Trabajadores del Mar. Armadores y asimilados por cuenta ajena Grupo 2B. Baja desde 1/1/2016",
		"0825": "Régimen Especial Trabajadores del Mar. Autónomos",
		"0911": "Minería del carbón",
		"3011": "Asistencia Sanitaria Concertada"
	},
	"T-3": {
		"1": "D.N.I., N.I.F.",
		"6": "Número de Identificación de Extranjero",
		"9": "Código de Identificación Fiscal",
		"K": "Españoles sin DNI menores de 14 años",
		"L": "Españoles sin DNI no residentes",
		"M": "Extranjeros sin NIF no residentes"
	},
	"T-8": {
		"1": "Individual",
		"2": "Colectivo",
		"3": "Sin personalidad jurídica",
		"4": "Entidad u Organismo de las Administraciones Públicas"
	},
	"T-10": {
		"001": "MC-MUTUAL",
		"002": "MUTUALIA",
		"003": "UMIVALE ACTIVA",
		"007": "MUTUA MONTAÑESA",
		"010": "MUTUA UNIVERSAL MUGENAT",
		"011": "M.A.Z.",
		"021": "MUTUA NAVARRA",
		"039": "MUTUA INTERCOMARCAL",
		"061": "F.R.E.M.A.P.",
		"072": "SOLIMAT",
		"115": "MUTUA DE ANDALUCÍA Y DE CEUTA (CESMA)",
		"151": "A.S.E.P.E.Y.O.",
		"183": "MUTUA BALEAR",
		"267": "UNIÓN DE MUTUAS UNIMAT",
		"272": "M.A.C. MUTUA DE ACCIDENTES CANARIA",
		"274": "IBERMUTUA",
		"275": "FRATERNIDAD-MUPRESPA",
		"276": "EGARSAT",
		"666": "EMPRESA COLABORADORA",
		"777": "I.N.S.S.",
		"888": "INSTITUTO SOCIAL DE LA MARINA",
		"999": "EMPRESA EXCLUIDA DE IT"
	},
	"T-11": {
		"1": "D.N.I. (N.I.F.)",
		"2": "Pasaporte",
		"6": "Número de Identificación de Extranjero",
		"L": "Españoles sin DNI no residentes en España",
		"M": "Extranjeros sin NIE en España"
	},
	"T-89": {
		"1": "Nacimiento de hijo",
		"2": "Parto múltiple",
		"3": "Fallecimiento de la madre (solo en caso de paternidad)",
		"4": "Adopción/tutela",
		"5": "Acogimiento",
		"6": "Opción a favor del otro progenitor (solo en caso de maternidad)"
	},
	"T-92": {
		"26": "No estar en alta en la fecha de baja",
		"37": "IT inexistente artículo 174.3 TRLGSS",
		"38": "Baja anulada por el INSS (artículo 170 TRLGSS)",
		"46": "Baja improcedente por baja contingencia profesional",
		"54": "Baja no reconocida por el INSS",
		"99": "Alta por error"
	},
	"T-93": {
		"1": "Curación",
		"2": "Fallecimiento",
		"3": "Inspección médica",
		"6": "Mejoría que permite realizar trabajo habitual",
		"7": "Incomparecencia",
		"8": "De oficio por vencimiento",
		"11": "Automática por otra baja",
		"12": "Aprobada Incapacidad Permanente",
		"13": "Denegada Incapacidad Permanente",
		"14": "Pase a Jubilación",
		"16": "Pase a Pago Directo del INSS/ISM",
		"17": "Recuperación de la capacidad profesional",
		"18": "Incomparecencia (contratos de formación)",
		"20": "Inicio de Maternidad comunicada por el SPS",
		"21": "Cambio de contingencia",
		"22": "Expediente sancionador",
		"23": "No presentar partes de confirmación",
		"24": "Curación. Incorporación al trabajo",
		"25": "No tener carencia",
		"27": "Pase a pago de Mutua",
		"28": "Pase a pago de Empresa",
		"29": "Incompatibilidad de prestación",
		"30": "Incomparecencia a reconocimiento médico",
		"31": "Extinción de la relación laboral",
		"33": "Proceso de empresa colaboradora",
		"34": "Proceso de empresa subrogada",
		"35": "Alta realizada desde unidades médicas",
		"36": "Alta a efectos económicos artículo 170 TRLGSS",
		"39": "Recuperación de capacidades profesionales (U. médicas)",
		"44": "Fin de IT por inicio de Maternidad",
		"45": "Fin de IT por inicio de Paternidad",
		"50": "Inicio de Maternidad (INSS + 365 días de IT)",
		"51": "Fallecimiento Ministerio de Justicia",
		"53": "Alta inspección INSS",
		"56": "Alta por fallecimiento INSS",
		"59": "Incomparecencia al SPS por propuesta de alta de Mutua",
		"64": "Finalizado por la Mutua vía protocolo 2",
		"70": "Suspensión cautelar por incomparecencia",
		"85": "Propuesta Incapacidad Permanente por agotamiento 365 días",
		"86": "Propuesta Incapacidad Permanente en prórroga de IT más de 365 días",
		"87": "Propuesta Incapacidad Permanente por agotamiento 545 días",
		"89": "Alta médica emitida 1ª resolución artículo 170 TRLGSS"
	},
	"T-94": {
		"1": "Curación",
		"2": "Fallecimiento",
		"3": "Inspección médica",
		"6": "Mejoría que permite realizar trabajo habitual",
		"7": "Incomparecencia",
		"8": "De oficio por vencimiento",
		"9": "De oficio por agotamiento de prórroga",
		"11": "Automática por otra baja",
		"12": "Aprobada Incapacidad Permanente",
		"13": "Denegada Incapacidad Permanente",
		"14": "Pase a Jubilación",
		"17": "Recuperación de la capacidad profesional",
		"18": "Incomparecencia (contratos de formación)",
		"20": "Inicio de Maternidad comunicada por el SPS",
		"21": "Cambio de contingencia",
		"22": "Expediente sancionador (fin de la prestación, pero no fin de la IT)",
		"23": "No presentar partes de confirmación (fin de la prestación, pero no fin de la IT)",
		"24": "Curación. Incorporación al trabajo",
		"25": "No tener carencia (fin de la prestación, pero no fin de la IT)",
		"29": "Incompatibilidad de prestación",
		"30": "Incomparecencia a reconocimiento médico",
		"35": "Alta realizada desde unidades médicas",
		"39": "Recuperación capacidades profesionales (Unidades médicas)",
		"42": "Alta por aplicación de la Ley de Medidas",
		"44": "Fin de IT por inicio de Maternidad",
		"45": "Fin de IT por inicio de Paternidad",
		"50": "Inicio de Maternidad (INSS + 365 días de IT)",
		"51": "Fallecimiento Ministerio de Justicia",
		"53": "Alta inspección INSS",
		"56": "Alta por fallecimiento INSS",
		"59": "Incomparecencia al SPS por propuesta de alta de Mutua",
		"61": "Agotamiento 545 días con carencia para Incapacidad Permanente",
		"62": "Agotamiento 545 días, denegación Incapacidad Permanente (≥ 65 años)",
		"64": "Finalizado por la Mutua vía protocolo 2",
		"67": "Agotamiento 730 días",
		"90": "Alta notificada 1ª resolución artículo 170 TRLGSS",
		"91": "Formulada disconformidad con el alta sin acuse de recibo",
		"92": "Nueva baja emitida por el SPS sin acuse de recibo"
	},
	"T-95": {
		"4": "Propuesta Incapacidad",
		"55": "Alta propuesta Incapacidad Permanente INSS",
		"85": "Propuesta Incapacidad Permanente por agotamiento 365 días",
		"86": "Propuesta Incapacidad Permanente en prórroga de IT > 365 días",
		"87": "Propuesta Incapacidad Permanente por agotamiento 545 días"
	},
	"T-102": {
		"5":   "ALTA MÉDICA POR LA INSPECCIÓN DEL INSS",
		"6":   "PROPUESTA DE IP, IT < 12 MESES",
		"3":   "ALTA MÉDICA POR INCOMPARECENCIA INJUSTIFICADA",
		"1B":  "ALTA MÉDICA ENTREGADA EN MANO AL TRABAJADOR",
		"11":  "ALTA MÉDICA ENVIADA POR CARTA AL TRABAJADOR",
		"12":  "PRÓRROGA DE IT",
		"13":  "PROPUESTA DE INCAPACIDAD PERMANENTE",
		"19":  "INICIO DE EXPEDIENTE DE INCAPACIDAD PERMANENTE POR AGOTAMIENTO 545 DÍAS",
		"21":  "DENEGACIÓN DE RECAÍDA (Con Baja del SPS)",
		"23":  "DENEGACIÓN DE RECAÍDA. PATOLOGÍA DIFERENTE (Con Baja del SPS)",
		"24":  "DENEGACIÓN DE RECAÍDA. PATOLOGÍA DIFERENTE (Solicitada en el INSS)",
		"25":  "PRÓRROGA DE IT POR RECAÍDA (Con Baja del SPS)",
		"26":  "PRÓRROGA DE IT POR RECAÍDA (Solicitada en el INSS)",
		"27":  "PROPUESTA DE INCAPACIDAD PERMANENTE POR RECAÍDA (Con Baja del SPS)",
		"28":  "PROPUESTA DE INCAPACIDAD PERMANENTE POR RECAÍDA (Solicitada en el INSS)",
		"40":  "RECAÍDA MISMA PATOLOGÍA. PROCEDE BAJA (Solicitada en el INSS)",
		"42":  "RECAÍDA DISTINTA PATOLOGÍA. PROCEDE BAJA (Solicitada en el INSS)",
		"44":  "RECAÍDA MISMA PATOLOGÍA. PROCEDE BAJA (Con Baja del SPS)",
		"45":  "RECAÍDA MISMA PATOLOGÍA. NO PROCEDE BAJA (Con Baja del SPS)",
		"46":  "RECAÍDA DISTINTA PATOLOGÍA. PROCEDE BAJA (Con Baja del SPS)",
		"50":  "APERTURA DE LA REVISIÓN DEL ALTA DE MUTUA PARA SU TRAMITACIÓN",
		"51":  "CONFIRMACIÓN DEL ALTA MÉDICA (De Contingencias Profesionales) EMITIDA POR LA MUTUA",
		"52":  "MANTENER SITUACIÓN DE IT (De Contingencias Profesionales). NO PROCEDE EL ALTA DE LA MUTUA",
		"53":  "MANTENER SITUACIÓN DE IT (De Contingencias Profesionales). NO PROCEDE EL ALTA DE LA MUTUA. LA NUEVA BAJA EMITIDA POR EL SPS/ICAM NO PROCEDE",
		"54":  "CONFIRMACIÓN DEL ALTA MÉDICA (De Contingencias Profesionales) EMITIDA POR LA MUTUA. LA NUEVA BAJA EMITIDA POR EL SPS/ICAM NO PROCEDE",
		"55":  "CONFIRMACIÓN DEL ALTA MÉDICA (De Contingencias Profesionales) EMITIDA POR LA MUTUA. LA NUEVA BAJA EMITIDA POR EL SPS/ICAM PROCEDE",
		"5B":  "NO PROCEDE TRAMITAR LA RECLAMACIÓN (Archivada sin resolución)",
		"5Z":  "ANULACIÓN POR PARTE DE LA MUTUA DEL ALTA EMITIDA",
		"5C":  "PASE AUTOMÁTICO DE RAMU A PIT",
		"D0":  "INICIO DE PROCEDIMIENTO DE DETERMINACIÓN DE CONTINGENCIA Y PETICIÓN DE ALEGACIONES",
		"D1":  "RESOLUCIÓN FIN DEL PROCEDIMIENTO DE DETERMINACIÓN DE CONTINGENCIA. Se estima el cambio de contingencia",
		"D2":  "RESOLUCIÓN FIN DEL PROCEDIMIENTO DE DETERMINACIÓN DE CONTINGENCIA. Se desestima el cambio de contingencia",
		"D3":  "RESOLUCIÓN FIN DEL PROCEDIMIENTO DE DETERMINACIÓN DE CONTINGENCIA. Se estima el cambio de contingencia y de recaída",
		"D7":  "RESOLUCIÓN FIN DEL PROCEDIMIENTO DE DETERMINACIÓN DE CONTINGENCIA. Empresa no es colaboradora"
	},
	provincias: {

		1: "Áraba/Álava",
		2: "Albacete",
		3: "Alacant",
		4: "Almería",
		5: "Ávila",
		6: "Badajoz",
		7: "Illes Balears",
		8: "Barcelona",
		9: "Burgos",
		10: "Cáceres",
		11: "Cádiz",
		12: "Castello",
		13: "Ciudad Real",
		14: "Córdoba",
		15: "A Coruña",
		16: "Cuenca",
		17: "Girona",
		18: "Granada",
		19: "Guadalajara",
		20: "Guipuzkoa",
		21: "Huelva",
		22: "Huesca",
		23: "Jaén",
		24: "León",
		25: "Lleida",
		26: "La Rioja",
		27: "Lugo",
		28: "Madrid",
		29: "Málaga",
		30: "Murcia",
		31: "Navarra",
		32: "Ourense",
		33: "Asturias",
		34: "Palencia",
		35: "Las Palmas",
		36: "Pontevedra",
		37: "Salamanca",
		38: "Tenerife",
		39: "Cantabria",
		40: "Segovia",
		41: "Sevilla",
		42: "Soria",
		43: "Tarragona",
		44: "Teruel",
		45: "Toledo",
		46: "Valencia",
		47: "Valladolid",
		48: "Bizcaia",
		49: "Zamora",
		50: "Zaragoza",
		51: "Ceuta",
		52: "Melilla",
	}
})